module.exports = __webpack_public_path__ + "img/vertical_6_1_7005.4ecb8b2d.png";